import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TimeoutError, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HandlerEndPointService {

  /* Variables para llamar a API */
  private readonly _urlApi: string = '/api/handler/';

  constructor(private http: HttpClient) { }

  protected getRequestHeaders() {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + '',
      'Content-Type': 'application/json',
      'Accept': `application/json, text/plain, */*`,
      'App-Version': '1.0',
      timeout: `${100000}`
    });

    return headers;
  }

  handleError(error: HttpErrorResponse) {
    if (error instanceof TimeoutError) {
      return throwError('En este momento no podemos realizar la operación. Por favor intente nuevamente más tarde.');
    }
    return throwError(error);
  }

    getData(params?: any): Observable<any> {
    const endpointUrl = this._urlApi + 'consultar';
    return new Observable((observer) => {
      this.http.get(endpointUrl, {
        params,
        headers: this.getRequestHeaders()
      }).pipe(
        catchError((error) => {
          observer.error(error); // 🛠️ dispara el error en el subscribe
          return [];
        })
      ).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete(); // ✅ se cierra correctamente el observable
        },
        error: (err) => {
          observer.error(err); // fallback por si el catchError no lo intercepta
        }
      });
    });
  }
  
  

  postData(params?: any): Observable<any> {
    const endpointUrl = this._urlApi + 'procesar';
    return new Observable((observer) => {
      this.http.post(endpointUrl, JSON.stringify(params), { headers: this.getRequestHeaders() }).pipe(
        catchError(error => this.handleError(error))
      ).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete(); // ✅ Esto hace que funcione el `.add()` o `complete`
        },
        error: (error) => {
          observer.error(error); // Mejor usar error para que lo capture bien el `subscribe.error`
        }
      });
    });
  }

}
